/* pc-event-banner.js: moved out of sections/event-banner.liquid inline script (Page Weight, Oct 2026). */
(function () {
  if (window.__pcEventBannerJs) return;
  window.__pcEventBannerJs = true;
  (function () {
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function parse(d, t, off) {
      d = (d || '').trim(); if (!d) return null;
      t = (t || '00:00').trim(); if (t.length === 4) t = '0' + t;
      var x = new Date(d + 'T' + t + ':00' + (off || '-05:00'));
      return isNaN(x) ? null : x.getTime();
    }
    function init(root) {
      if (!root || root.getAttribute('data-eb-ready')) return;
      root.setAttribute('data-eb-ready', '1');
      var design = !!(window.Shopify && Shopify.designMode);
      var leadMs = (parseFloat(root.getAttribute('data-lead')) || 7) * 864e5;
      var hideEnded = root.getAttribute('data-hide-ended') === 'true';
      var pinned = null;

      var items = Array.prototype.slice.call(root.querySelectorAll('[data-eb-item]')).map(function (el) {
        var off = el.getAttribute('data-offset');
        return {
          el: el, stream: el.getAttribute('data-type') === 'stream',
          start: parse(el.getAttribute('data-start'), '00:00', off),
          end: parse(el.getAttribute('data-date'), el.getAttribute('data-time'), off),
          liveMs: (parseFloat(el.getAttribute('data-live-hours')) || 0) * 36e5,
          repeat: el.getAttribute('data-repeat') === 'true',
          type: el.getAttribute('data-type'),
          promo: el.getAttribute('data-type') === 'promo',
          daily: el.getAttribute('data-type') === 'daily',
          d: el.querySelector('[data-eb-d]'), h: el.querySelector('[data-eb-h]'), m: el.querySelector('[data-eb-m]'), s: el.querySelector('[data-eb-s]'),
          fill: el.querySelector('[data-eb-fill]')
        };
      });
      /* Whatnot streams always lead the rotation, wherever their block sits */
      items = items.filter(function (i) { return i.stream; }).concat(items.filter(function (i) { return !i.stream; }));

      if (root.getAttribute('data-dismiss') === 'true') {
        var key = 'eb-dismiss-' + items.map(function (i) { return i.end; }).join('-');
        var gone = false; try { gone = sessionStorage.getItem(key) === '1'; } catch (e) {}
        if (!gone || design) root.hidden = false;
        var x = root.querySelector('[data-eb-close]');
        if (x) x.addEventListener('click', function () { root.hidden = true; try { sessionStorage.setItem(key, '1'); } catch (e) {} });
      }

      /* daily giveaway: today's prize and draw time come from the Poke-Collect Giveaways app */
      function fill(tpl, d) {
        return (tpl || '').replace(/\{(\w+)\}/g, function (m, k) { return d[k] != null ? d[k] : ''; }).replace(/\s+·\s*$/, '').trim();
      }
      /* Product photos often have wide empty margins; find the visible area on a small canvas and
         use Shopify's region crop of just that area (Shopify CDN images only). */
      function trimImage(img, url) {
        if (!/^https:\/\/cdn\.shopify\.com\//.test(url)) return;
        var probe = new Image(); probe.crossOrigin = 'anonymous';
        probe.onload = function () {
          try {
            var w = probe.naturalWidth, h = probe.naturalHeight, n = 120, c = document.createElement('canvas');
            c.width = n; c.height = n;
            var ctx = c.getContext('2d'); ctx.drawImage(probe, 0, 0, n, n);
            var px = ctx.getImageData(0, 0, n, n).data, x0 = n, y0 = n, x1 = -1, y1 = -1;
            for (var y = 0; y < n; y++) for (var x = 0; x < n; x++) {
              var i = (y * n + x) * 4;
              if (px[i + 3] < 40 || (px[i] > 244 && px[i + 1] > 244 && px[i + 2] > 244)) continue;
              if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y;
            }
            if (x1 <= x0 || y1 <= y0) return;
            x0 = Math.max(0, x0 - 2); y0 = Math.max(0, y0 - 2); x1 = Math.min(n - 1, x1 + 2); y1 = Math.min(n - 1, y1 + 2);
            if ((x1 - x0 + 1) * (y1 - y0 + 1) / (n * n) >= 0.9) return;
            var u = new URL(url);
            u.searchParams.set('crop', 'region');
            u.searchParams.set('crop_left', String(Math.floor(x0 / n * w)));
            u.searchParams.set('crop_top', String(Math.floor(y0 / n * h)));
            u.searchParams.set('crop_width', String(Math.ceil((x1 - x0 + 1) / n * w)));
            u.searchParams.set('crop_height', String(Math.ceil((y1 - y0 + 1) / n * h)));
            u.searchParams.set('width', '160');
            img.src = u.toString();
          } catch (e) { /* keep the original picture */ }
        };
        probe.src = url;
      }
      function loadDaily(it) {
        var slug = it.el.getAttribute('data-slug'); if (!slug) return;
        fetch(it.el.getAttribute('data-proxy') + '/' + encodeURIComponent(slug), { headers: { accept: 'application/json' }, credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (j) {
            if (!j || !j.daily || !j.daily.drawAt) { it.el.classList.remove('is-waiting'); it.el.classList.add('is-promo'); return; }
            var p = j.daily.prize || {}, at = new Date(j.daily.drawAt);
            it.end = at.getTime();
            var time = '';
            try { time = at.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', timeZone: 'America/Chicago' }).replace(':00', '') + ' CT'; } catch (e) {}
            var d = { prize: p.title || '', value: p.value ? '$' + (p.value % 1 ? Number(p.value).toFixed(2) : p.value) : '', time: time };
            var tt = it.el.querySelector('[data-eb-title]'), st = it.el.querySelector('[data-eb-sub]');
            if (tt && p.title) tt.textContent = fill(it.el.getAttribute('data-title-tpl'), d) || p.title;
            if (st) st.textContent = fill(it.el.getAttribute('data-sub-tpl'), d);
            var th = it.el.querySelector('[data-eb-thumb]');
            var parts = (p.items || []).filter(function (x) { return x && x.imageUrl; });
            if (th && parts.length && (parts.length > 1 || parts[0].quantity > 1)) {
              /* bundle prize: every product's picture, trimmed, with "3x" on repeated ones */
              th.innerHTML = ''; th.classList.add('is-prize', 'is-bundle'); th.removeAttribute('style');
              parts.slice(0, 4).forEach(function (x) {
                var box = document.createElement('span'); box.className = 'eb-part';
                var im = new Image(); im.alt = ''; im.decoding = 'async';
                im.src = x.imageUrl + (x.imageUrl.indexOf('?') < 0 ? '?' : '&') + 'width=160';
                trimImage(im, x.imageUrl);
                box.appendChild(im);
                if (x.quantity > 1) { var q = document.createElement('b'); q.className = 'eb-qty'; q.textContent = x.quantity + 'x'; box.appendChild(q); }
                th.appendChild(box);
              });
            } else if (th && p.imageUrl) {
              var im = new Image(); im.alt = ''; im.decoding = 'async';
              im.src = p.imageUrl + (p.imageUrl.indexOf('?') < 0 ? '?' : '&') + 'width=160';
              th.innerHTML = ''; th.appendChild(im); th.classList.add('is-prize'); th.removeAttribute('style');
            }
            it.el.classList.remove('is-waiting');
            tick();
          })
          .catch(function () { it.el.classList.remove('is-waiting'); it.el.classList.add('is-promo'); });
      }
      items.forEach(function (it) { if (it.daily) loadDaily(it); });

      function set(el, v) { if (el && el.textContent !== v) { el.textContent = v; el.classList.remove('tick'); void el.offsetWidth; el.classList.add('tick'); } }

      var rotate = root.getAttribute('data-rotate') === 'true';
      var rotateMs = Math.max(3, parseFloat(root.getAttribute('data-rotate-secs')) || 7) * 1000;
      var rIdx = 0, rAt = Date.now(), paused = false, dotsEl = root.querySelector('[data-eb-dots]'), dotsKey = '';
      function running(it, now) {
        if (it.promo) return !(it.start && now < it.start);
        if (it.daily) {
          if (!it.end) return true;                                   /* still loading: show it with its fallback text */
          if (now >= it.end) { it.end += 864e5; loadDaily(it); }       /* tonight's draw done: tomorrow's prize */
          return true;
        }
        if (!it.end) return false;
        if (it.stream && it.repeat) { while (now > it.end + it.liveMs) it.end += 7 * 864e5; }
        if (it.end + (it.stream ? it.liveMs : 0) <= now) return false;
        if (it.start && now < it.start) return false;
        return true;
      }
      function go(i) { rIdx = i; rAt = Date.now(); tick(); }
      function drawDots(list) {
        if (!dotsEl) return;
        var key = list.map(function (x) { return items.indexOf(x); }).join(',');
        if (key !== dotsKey) {
          dotsKey = key; dotsEl.innerHTML = '';
          list.forEach(function (x, i) {
            var b = document.createElement('button'); b.type = 'button';
            b.setAttribute('aria-label', 'Show banner ' + (i + 1) + ' of ' + list.length);
            b.addEventListener('click', function () { go(i); });
            dotsEl.appendChild(b);
          });
          dotsEl.hidden = list.length < 2;
        }
        Array.prototype.forEach.call(dotsEl.children, function (b, i) { b.setAttribute('aria-current', i === rIdx ? 'true' : 'false'); });
      }
      if (rotate) {
        root.addEventListener('mouseenter', function () { paused = true; });
        root.addEventListener('mouseleave', function () { paused = false; rAt = Date.now(); });
        root.addEventListener('focusin', function () { paused = true; });
        root.addEventListener('focusout', function () { paused = false; rAt = Date.now(); });
        var sx = null, sy = null;
        root.addEventListener('touchstart', function (e) { var t = e.touches[0]; sx = t.clientX; sy = t.clientY; }, { passive: true });
        root.addEventListener('touchend', function (e) {
          if (sx == null) return; var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy; sx = null;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.3) { var n = dotsEl ? dotsEl.children.length : 1; go((rIdx + (dx < 0 ? 1 : -1) + n) % n); }
        }, { passive: true });
      }

      function pick(now) {
        if (pinned) return pinned;
        if (rotate) {
          var list = items.filter(function (it) { return running(it, now); });
          items.forEach(function (it) { it.el.classList.toggle('is-out', list.indexOf(it) < 0); it.el.setAttribute('aria-hidden', 'true'); });
          if (!list.length) return null;
          if (!paused && now - rAt >= rotateMs) { rIdx++; rAt = now; }
          rIdx = rIdx % list.length;
          drawDots(list);
          list[rIdx].el.removeAttribute('aria-hidden');
          return list[rIdx];
        }
        // the banner whose countdown (or live window) finishes soonest, among those that have started showing
        var best = null;
        items.forEach(function (it) {
          if (!it.end) return;
          if (it.stream && it.repeat) { while (now > it.end + it.liveMs) it.end += 7 * 864e5; }
          var finish = it.end + (it.stream ? it.liveMs : 0);
          if (finish <= now) return;
          if (it.start && now < it.start) return;
          if (!best || finish < best.end + (best.stream ? best.liveMs : 0)) best = it;
        });
        return best;
      }

      var current = null;
      function tick() {
        var now = Date.now();
        var it = pick(now);
        if (it !== current) {
          items.forEach(function (x) { x.el.classList.toggle('is-current', x === it); });
          current = it;
        }
        if (!it) {
          if (!design && hideEnded) { root.hidden = true; return; }
          var last = items[items.length - 1];
          if (last) { last.el.classList.add('is-current', 'is-ended'); }
          return;
        }
        if (root.hidden && root.getAttribute('data-dismiss') !== 'true') root.hidden = false;
        if (it.promo || !it.end) return;
        var diff = it.end - now;
        var live = it.stream && diff <= 0 && diff > -it.liveMs;
        it.el.classList.toggle('is-live', live);
        it.el.classList.toggle('is-ended', diff <= 0 && !live);
        it.el.classList.toggle('is-soon', !live && diff > 0 && diff < 36e5);
        if (diff > 0) {
          var t = Math.floor(diff / 1000);
          set(it.d, pad(Math.floor(t / 86400))); set(it.h, pad(Math.floor(t % 86400 / 3600)));
          set(it.m, pad(Math.floor(t % 3600 / 60))); set(it.s, pad(t % 60));
          var lead = it.daily ? 864e5 : leadMs;
          if (it.fill) it.fill.style.width = Math.max(0, Math.min(100, (1 - diff / lead) * 100)).toFixed(2) + '%';
        }
      }
      // theme editor: clicking a block shows it
      root.addEventListener('eb:select', function (e) { pinned = items.filter(function (i) { return i.el === e.detail; })[0] || null; tick(); });
      root.addEventListener('eb:deselect', function () { pinned = null; tick(); });
      tick();
      setInterval(tick, 1000);
    }
    function initAll() { document.querySelectorAll('[data-eb]').forEach(init); }

    /* The theme measures the sticky header while the page is still loading (before the custom menu is ready),
       which can leave an empty strip under the header. Measure it again once everything has loaded. */
    function fixHeaderGap() {
      var sh = document.querySelector('sticky-header');
      if (!sh || typeof sh.calculateHeaderHeight !== 'function') return;
      sh.calculateHeaderHeight();
      if (!sh.fullHeaderHeight) return;
      document.body.style.setProperty(window.innerWidth >= 990 ? '--sticky-header-height-desktop' : '--sticky-header-height-mobile', sh.fullHeaderHeight + 'px');
      if (sh.headerHeight) document.body.style.setProperty('--header-height', sh.headerHeight + 'px');
    }
    window.addEventListener('load', function () { fixHeaderGap(); setTimeout(fixHeaderGap, 1200); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fixHeaderGap);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
    document.addEventListener('shopify:section:load', initAll);
    ['select', 'deselect'].forEach(function (k) {
      document.addEventListener('shopify:block:' + k, function (e) {
        var item = e.target && e.target.closest ? e.target.closest('[data-eb-item]') : null;
        if (!item) return;
        item.closest('[data-eb]').dispatchEvent(new CustomEvent('eb:' + k, { detail: item }));
      });
    });
  })();
})();
